import { render } from "./ContentPict.vue?vue&type=template&id=80d597b0"
import script from "./ContentPict.vue?vue&type=script&lang=js"
export * from "./ContentPict.vue?vue&type=script&lang=js"
script.render = render

export default script